import { useState } from "react";
import authService from "./api-authorization/AuthorizeService";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { JobSearchResults } from "./models/JobInterfaces";

interface JobSearchProps {
    readonly: boolean;
    searching(): void;
    addJob(job: JobSearchResults): void;
    removeJob(jobId: number): void;
}

const JobSearchControlData = (props: JobSearchProps) => {
    const [jobId, setJobId] = useState(0);
    const [siteAddress, setSiteAddress] = useState("");
    const [searchingJobs, setSearchingJobs] = useState(false);
    const [showJobResults, setShowJobResults] = useState(false);
    const [jobResults, setJobResults] = useState<JobSearchResults[]>([]);
    const [errorMessage, setErrorMessage] = useState("");

    const onKeyUp = (e: any) => {
        //check if enter key has been pressed and if so call search
        if (e.keyCode === 13) {
            searchJobs();
        }
    }

    const resetScreenForNewSearch = () => {
        setSearchingJobs(true);
        props.searching();
        setShowJobResults(false);
        setJobResults([]);
        setErrorMessage("");
    }

    const searchJobs = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        resetScreenForNewSearch();

        axios.get('api/Job/SearchJobsByIdSiteAddress?JobId=' + jobId + '&SiteAddress=' + siteAddress + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError && res.data.jobs.length === 0) {
                var errors = res.data.messages as any[];
                var errMessage = "";
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                    errMessage += errors[i].content;
                };
                setErrorMessage(errMessage);
                setShowJobResults(false);
                setSearchingJobs(false);
            } else {
                var jobs = res.data.jobs;
                setSearchingJobs(false);
                if (jobs.length === 0) {
                    setErrorMessage("No jobs were found matching your search criteria.");
                } else {
                    setShowJobResults(true);
                    if (jobs.length === 1) {
                        //auto select job
                        jobs[0].selected = true;
                        props.addJob(jobs[0]);
                    }
                    setJobResults(jobs);
                }
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const selectJobItem = (e: any, updatedIndex: number) => {
        setJobResults(prevState => prevState.map((item, index) =>
            index == updatedIndex ? { ...item, selected: e.target.checked } : item
        ));

        if (e.target.checked) {
            props.addJob(jobResults[updatedIndex]);
        } else {
            //remove from list
            props.removeJob(jobResults[updatedIndex].jobId);
        }
    }

    return (
        <div>
            <div className="makeitflex">
                <label className="input-group--inline" htmlFor="jobIdSearch">
                    <span className="label">Job Id</span>
                    <input className="input schedulenew__addSearch--width-sm" type="text" id="jobIdSearch" name="jobIdSearch" value={jobId} onChange={(e) => { setErrorMessage(""); setJobId(Number(e.target.value)) }} onKeyUp={(e) => onKeyUp(e)}></input>
                </label>
                <label className="input-group--inline" htmlFor="siteAddressSearch">
                    <span className="label label--setsizesm">Site Address</span>
                    <input className="input schedulenew__addSearch--width-lg" type="text" id="siteAddressSearch" name="siteAddressSearch" value={siteAddress} onChange={(e) => { setErrorMessage(""); setSiteAddress(e.target.value) }} onKeyUp={(e) => onKeyUp(e)}></input>
                </label>
                <button className="defaultbutton defaultbutton__small allocate__searchMargin" type='button' onClick={() => searchJobs()} disabled={props.readonly || searchingJobs}>Search</button>
            </div>
            <div className="schedulePickupError">{errorMessage}</div>
            <div className={searchingJobs ? "" : "hidden" }>Searching Jobs...</div>

            <div className={showJobResults && jobResults.length > 0 ? '' : 'hidden'}>
                <table className='table tableColours schedulePickupsTableWidth'>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th>Job Id</th>
                            <th>Site Address</th>
                            <th>Customer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobResults.map((result, index) =>
                            <tr key={index}>
                                <td className="table__text--align">{index + 1}</td>
                                <td className="table__text--align"><input type='checkbox' className="input" checked={result.selected} onChange={(e) => selectJobItem(e, index)} /></td>
                                <td className="table__text--align">
                                    <Link to={'/job/' + result.jobId} target="_blank" >
                                        {result.jobId}
                                    </Link>
                                </td>
                                <td className="table__text--align">{result.siteAddress}</td>
                                <td className="table__text--align">{result.customerName}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default JobSearchControlData;